import React, { useState, useEffect } from "react";
import { Switch } from "@headlessui/react";

interface ToggleSwitchProps {
  value: boolean;
  onPress: (enabled: boolean) => void;
  isLoading?: boolean;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  value,
  onPress,
  isLoading = false,
}) => {
  const [enabled, setEnabled] = useState(value);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    setEnabled(value);
    setIsTransitioning(false);
  }, [value]);

  const handleChange = (newValue: boolean) => {
    if (isTransitioning || isLoading) return;

    console.log("[prefs] handleChange triggered with value:", newValue);
    setIsTransitioning(true);
    setEnabled(newValue);
    onPress(newValue);
  };

  return (
    <div className="relative pr-6">
      <Switch
        checked={enabled}
        onChange={handleChange}
        disabled={isTransitioning || isLoading}
        className={`${
          enabled ? "bg-green-600" : "bg-gray-200"
        } relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-in-out
        ${
          isTransitioning || isLoading
            ? "opacity-50 cursor-not-allowed"
            : "cursor-pointer"
        }
        `}
      >
        <span className="sr-only">Enable notifications</span>
        <span
          className={`${
            enabled ? "translate-x-6" : "translate-x-1"
          } inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ease-in-out
          ${isTransitioning || isLoading ? "animate-pulse" : ""}`}
        />
      </Switch>
      {(isTransitioning || isLoading) && (
        <svg
          className="animate-spin h-4 w-4 text-green-600 absolute -right-1 top-1"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
    </div>
  );
};
